<shirase-t-header></shirase-t-header>

<div class="contents">
  <router-outlet></router-outlet>
</div>

<shirase-wrapper-gam></shirase-wrapper-gam>
<shirase-t-footer></shirase-t-footer>
<shirase-t-top-scroll></shirase-t-top-scroll>
